import React from 'react';
import { Canvas } from '@react-three/fiber';
import Model3DView from './Model3DView';

/**
 * ModuleViewer component
 *
 * Renders a 3D view using the Model3DView component.
 *
 * @param {object} props - Component props
 * @param {array} props.selectedModules - Array of selected modules to be rendered
 *
 */

function ModuleViewer({ selectedModules }) {
    return (
        <div className="viewer" >
           {/*}  <Rack2DView selectedModules={selectedModules} /> {/* 2D View */}
            <Canvas>
                <Model3DView selectedModules={selectedModules} /> {/* 3D View */}
            </Canvas>
        </div>
    );
}

export default ModuleViewer;
